import createReactComponent from '../createReactComponent';
export default createReactComponent('arrows-up-from-line', 'ArrowsUpFromLine', [["path",{"d":"m4 7 3-4m0 0 3 4M7 3v14m7-10 3-4m0 0 3 4m-3-4v14M4 21h16","key":"svg-0"}]]);